import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language.startsWith('pt') ? 'en' : 'pt';
    i18n.changeLanguage(newLang);
    document.documentElement.lang = newLang;
  };

  const currentLang = i18n.language.startsWith('pt') ? 'PT' : 'EN';
  const nextLang = i18n.language.startsWith('pt') ? 'English' : 'Português';

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg border border-gray-300 hover:border-teal-600 hover:bg-teal-50 transition-all duration-200"
      aria-label={`Alterar idioma para ${nextLang} - Change language to ${nextLang}`}
      title={`${currentLang} - Clique para mudar para ${nextLang}`}
    >
      <Globe size={18} className="text-teal-600" aria-hidden="true" />
      <span className="font-medium text-gray-700">{currentLang}</span>
    </button>
  );
};

export default LanguageSwitcher;
